export function isComponentUriEncoded(input: string): input is EncodedURIComponentString {
  return true
}

export function isComponentUriDecoded(input: string): input is DecodedURIComponentString {
  return !isComponentUriEncoded(input)
}
